import { FixedMarker, FixedMarkerOverrides } from 'baseui/map-marker';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { timelineRecordPathsState } from '../../../storage/streaming';

function CapturingVideoPathsMarkers() {
  const paths = useRecoilValue(timelineRecordPathsState);

  const fixedMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  if (!paths || !paths.length || paths.length > 1) return null;

  const path = paths[0];

  const startPoint = { lat: path.startPoint.coordinates[1], lng: path.startPoint.coordinates[0] };
  const endPoint = { lat: path.endPoint.coordinates[1], lng: path.endPoint.coordinates[0] };

  return (
    <>
      <Marker
        latitude={startPoint.lat}
        longitude={startPoint.lng}
      >
        <FixedMarker
          label="Inicio"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
      <Marker
        latitude={endPoint.lat}
        longitude={endPoint.lng}
      >
        <FixedMarker
          label="Fin"
          size="small"
          overrides={fixedMarkerOverrides}
        />
      </Marker>
    </>
  );
}

export default memo(CapturingVideoPathsMarkers);
